import GM_Helper from './gm-helper.js';

const blogSection = document.querySelector('.gm-blog');
const blogNav = document.getElementById('blog-category-nav');
const blogWrapper = document.getElementById('blog-wrapper');
const postsContainer = document.getElementById('blog-posts-container');

if (blogNav && postsContainer && blogWrapper && blogSection) {
    const categoryLinks = blogNav.querySelectorAll('a');

    const handleCategoryClick = (e) => {
        const link = e.target.closest('a[data-category]');
        if (!link) return;

        e.preventDefault();
        const categoryId = link.getAttribute('data-category');
        const url = link.getAttribute('href');

        if (link.getAttribute('aria-selected') === 'true') return;

        filterPosts(categoryId, url);
    };

    blogNav.addEventListener('click', handleCategoryClick);
    postsContainer.addEventListener('click', (e) => {
        if (e.target.closest('.overline a')) {
            handleCategoryClick(e);
        }
    });

    window.addEventListener('popstate', () => {
        const currentUrl = window.location.href;
        const normalizedUrl = currentUrl.endsWith('/') ? currentUrl : currentUrl + '/';

        const activeLink = Array.from(categoryLinks).find(link => {
            const linkUrl = link.href;
            const normalizedLinkUrl = linkUrl.endsWith('/') ? linkUrl : linkUrl + '/';
            return normalizedLinkUrl === normalizedUrl;
        });

        if (activeLink) {
            const categoryId = activeLink.getAttribute('data-category');
            filterPosts(categoryId, currentUrl, false);
        } else if (window.location.pathname.endsWith('/blog/') || window.location.pathname.endsWith('/blog')) {
             // Fallback for main blog page if no exact link match
             const mainLink = blogNav.querySelector('a[data-category="0"]');
             if (mainLink) filterPosts(mainLink.getAttribute('data-category'), mainLink.getAttribute('href'), false);
        }
    });
}

/**
 * Filter posts via AJAX
 * @param {string} categoryId
 * @param {string} url
 * @param {boolean} pushState
 */
async function filterPosts(categoryId, url, pushState = true) {
    blogWrapper.classList.add('is-loading');

    const formData = new FormData();
    formData.append('action', 'gm_filter_posts');
    formData.append('category', categoryId);
    formData.append('nonce', gm_params.nonce);

    try {
        const response = await fetch(gm_params.ajax_url, {
            method: 'POST',
            body: formData
        });

        const data = await response.json();

        if (data.success) {
            postsContainer.innerHTML = data.data;

            updateUI(categoryId, url, pushState);
            GM_Helper.smoothScrollTo(blogSection);
        }
    } catch (error) {
        console.error('Error filtering posts:', error);
    } finally {
        setTimeout(() => {
            blogWrapper.classList.remove('is-loading');
        }, 300); // Allow fade out to begin before fully removing class (matches CSS transition)
    }
}

/**
 * Update UI state
 * @param {string} categoryId
 * @param {string} url
 * @param {boolean} doPushState
 */
function updateUI(categoryId, url, doPushState) {
    const categoryLinks = blogNav.querySelectorAll('a');
    categoryLinks.forEach(link => {
        if (link.getAttribute('data-category') === categoryId) {
            link.setAttribute('aria-selected', 'true');
        } else {
            link.removeAttribute('aria-selected');
        }
    });

    if (doPushState) {
        history.pushState(null, '', url);
    }
}
